import { Pipe, PipeTransform } from '@angular/core';
import MetaFileLink, { MediaType } from 'src/app/models/metaFileLink.model';


@Pipe({ name: 'mediaFileIcon' })
export class MediaFileIconPipe implements PipeTransform {

  transform(metaFileLink: MetaFileLink): string {

    const mediaType = MetaFileLink.GetMediaType(metaFileLink);
    switch (mediaType) {
      case MediaType.Unknown:
      default:
        return 'file_icon_general';
      case MediaType.Image:
        return 'file_icon_image';
      case MediaType.TextDocument:
      case MediaType.Pdf:
        return 'file_icon_doc';
      case MediaType.Spreadsheet:
        return 'file_icon_spreadsheet';
      case MediaType.Presentation:
        return 'file_icon_presentation';
      case MediaType.Video:
        return 'file_icon_video';
      case MediaType.Audio:
        return 'file_icon_audio';
    }
  }
}
